import { getAuthority } from '@/api/newApi/header';
import { dispatchUserLimit } from '@/redux/action';

export type UserLimitData = Record<string, any>;

/** 物料编码等场景按需加载：Redux 已有数据或 API 已缓存时不再重复请求 */
export function ensureUserLimitLoaded(
  dispatch: (action: unknown) => void,
  existingLimitData?: UserLimitData | null,
): Promise<UserLimitData | null> {
  if (existingLimitData) {
    return Promise.resolve(existingLimitData);
  }

  return getAuthority()
    .then((res: any) => {
      if (!res?.success || !res?.value) {
        return null;
      }
      dispatch(dispatchUserLimit(res.value));
      return res.value as UserLimitData;
    })
    .catch(error => {
      console.error('ensureUserLimitLoaded failed', error);
      return null;
    });
}
